import {
  isRealm,
  REALMS,
  convertGradeToYearsInSchool,
  convertYearsInSchoolToGrade,
  getPossibleGrades,
} from '@ilteducation/grade-helpers';

const useGradeHelpers = (realm: string) => {
  if (!isRealm(realm)) {
    throw new Error(`Invalid realm: ${realm}. Expected one of: ${REALMS.join(', ')}`);
  }

  const convertYearsInSchoolToGradeHelper = (yearsInSchool: number): string | undefined =>
    convertYearsInSchoolToGrade(realm, yearsInSchool);

  const convertGradeToYearsInSchoolHelper = (grade: string): number | undefined =>
    convertGradeToYearsInSchool(realm, grade);

  const getPossibleGradesHelper = () => getPossibleGrades(realm);

  return {
    convertYearsInSchoolToGrade: convertYearsInSchoolToGradeHelper,
    convertGradeToYearsInSchool: convertGradeToYearsInSchoolHelper,
    getPossibleGrades: getPossibleGradesHelper,
  };
};

export default useGradeHelpers;
